import React from 'react';
import { Sparkles } from 'lucide-react';

interface ShimmerButtonProps {
  onClick: () => void;
  disabled?: boolean;
  isLoading?: boolean;
  children?: React.ReactNode;
  className?: string;
}

export const ShimmerButton: React.FC<ShimmerButtonProps> = ({
  onClick,
  disabled = false,
  isLoading = false,
  children,
  className = ''
}) => {
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={`
        relative px-8 py-3 
        bg-gradient-to-r from-cyan-500 via-blue-600 to-purple-600 
        hover:from-cyan-600 hover:via-blue-700 hover:to-purple-700
        text-white font-bold rounded-xl 
        shadow-xl shadow-blue-500/50 
        hover:shadow-2xl hover:shadow-blue-600/50
        disabled:opacity-50 disabled:cursor-not-allowed disabled:shadow-none
        transition-all duration-300 
        transform hover:scale-105 active:scale-95
        flex items-center gap-2
        overflow-hidden group
        ${className}
      `}
    >
      {/* Shimmer effect - only shows when loading */}
      {isLoading && (
        <div className="absolute inset-0 -translate-x-full animate-shimmer bg-gradient-to-r from-transparent via-white/30 to-transparent" />
      )}
      
      {isLoading ? (
        <>
          {/* Rotating circle spinner with arrow */}
          <svg 
            className="animate-spin h-5 w-5 text-white" 
            xmlns="http://www.w3.org/2000/svg" 
            fill="none" 
            viewBox="0 0 24 24"
          >
            <circle 
              className="opacity-25" 
              cx="12" 
              cy="12" 
              r="10" 
              stroke="currentColor" 
              strokeWidth="4"
            ></circle>
            <path 
              className="opacity-75" 
              fill="currentColor" 
              d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
            ></path>
          </svg>
          <span className="relative">Analyzing...</span>
        </>
      ) : (
        <>
          <Sparkles className="w-5 h-5 relative" />
          <span className="relative">{children || 'Analyze'}</span>
        </>
      )}
    </button>
  );
};

export default ShimmerButton;